<script setup>
import { onMounted, ref, computed } from 'vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import { onClickOutside } from '@vueuse/core'
import StepOne from '@/components/layouts/mega-menu/StepOne.vue'
import StepTwo from '@/components/layouts/mega-menu/StepTwo.vue'
import StepThree from '@/components/layouts/mega-menu/StepThree.vue'
import PromotionStep from '@/components/layouts/mega-menu/PromotionStep.vue'

const MenuRepo = RepositoryFactory.get('MegaMenu')
import { useStore } from 'vuex'

const dynamicRef = ref(null)
onClickOutside(dynamicRef, () => {
  store.dispatch('megaMenu/closeMenu')
})

const store = useStore()
const promotionBanners = ref([])
const secondLevelItems = ref([])
const thirdLevelItems = ref([])
const menuItems = ref('')
const list = ref('')
const mobileMenuHeight = ref('')
const mobileMenuWidth = ref('')
const KONKOORI_LINK ='?courses=&grades=2&lessons=&professors=&fields=&is_free=false'
mobileMenuHeight.value = window.innerHeight
mobileMenuWidth.value = window.innerWidth
const latestStepsSelected =ref([])
const menuHeight = ref('')
const isOpenMenu = ref(false)
const menuStatus = computed(() => store.getters['megaMenu/menu'])
isOpenMenu.value = menuStatus.value
onMounted(async () => {
  try {
    const { data } = await MenuRepo.get()
    promotionBanners.value = data.filter(item => item.is_promotion)
    menuItems.value = data.filter(item => !item.is_promotion)
  } catch (e) {
    console.log(e)
  }
})
const changeStateMegaMenu = (param) => {
  if (param) {
    store.dispatch('megaMenu/openMenu')
  } else {
    store.dispatch('megaMenu/closeMenu')
  }
}


const openNextMenuLevel = (menuItem) => {
  //menuItem index 0 equals to parent id and index 1 equals to level of item
  const secondLevelTemp = []
  const thirdLevelTemp = []
  lastStepKeeper(menuItem.level_name, menuItem.level_item)

  function recurse(items) {
    for (const item of items) {
      if (item.parent_id === menuItem.parent_id) {
        if (item.level === 3 && !item.description) {
          secondLevelTemp.push(item)
        }
        if (item.level === 4 || item.description) {
          thirdLevelTemp.push(item)
        }
      }
      if (item.children.length) {
        recurse(item.children)
      }
    }
  }

  recurse(menuItems.value)
  if (menuItem.level_item === 1) {
    secondLevelItems.value = []
  }
  if (!secondLevelItems.value.length) {
    secondLevelItems.value = secondLevelTemp
  }
  thirdLevelItems.value = thirdLevelTemp
  menuHeight.value = document.getElementById('menu').offsetHeight
  // number[0] === 2 ? this.stepOneValue = number[1] : this.stepTwoValue = number[1]
  // this.$router.replace({query: {grade_id: this.stepOneValue, measure_id: this.stepTwoValue}})
}


const lastStepKeeper = (levelName, level) => {
  level == 1 ? latestStepsSelected.value[0] = levelName: latestStepsSelected.value[1] = levelName
}
const backToPrevStep = (level)=>{
  level == 1 ? secondLevelItems.value = [] : thirdLevelItems.value = []
}


</script>
<template>
  <v-menu
    v-model="menuStatus"
    opacity="0.1"
    :scrim="true"
    content-class="mega__menu__mobile"
    :min-width="$vuetify.display.mdAndDown? mobileMenuHeight:''"
    :close-on-content-click="false"
    transition="slide-y-transition"
    scroll-strategy="block"
  >
    <template v-slot:activator="{ props }">
      <ul class="cl-courses-menu">
        <li>
          <router-link :to="{ name: 'home' }" class="logo-classino" append>
            <img src="@/assets/images/logo/classinoLogo.svg" alt="لوگو کلاسینو - Classino logo" width="121" height="38">
          </router-link>
        </li>
        <li>
          <v-btn size="default" width="120px" @click="changeStateMegaMenu(true)" v-bind="props"
                 variant="tonal"
                 class="font-weight-bold rounded-lg" color="primary" append-icon="$mdiChevronDown">
            دوره‌ها
          </v-btn>
        </li>
        <li class="mr-1">
          <v-btn size="default" width="120px" class="text-decoration-none" :to="{name:'courses' , query: {grades: 2}}"
                 variant="text">
            کنکوری‌ها
          </v-btn>
        </li>
        <li class="mr-1">
          <v-btn size="default" width="120px" class="text-decoration-none" :to="{ name: 'talentedStudents' }"
                 variant="text">
            تیزهوشان
          </v-btn>
        </li>
        <li class="mr-1">
          <v-btn size="default" id="ostadino" width="120px" class="text-decoration-none" append-icon="$mdiChevronDown"
                 variant="text">
            استادینو
          </v-btn>
          <v-menu activator="#ostadino" class="elevation-0" content-class="elevation-0" scroll-strategy="block">
            <v-list>
              <v-list-item>
                <v-list-item-title class="my-2">
                  <v-btn width="100%" variant="text" :to="{name:'ostadino'}" class="text-decoration-none p-2 text-black">مشاهده مسابقه </v-btn>
                </v-list-item-title>
                <v-list-item-title class="my-2">
                  <v-btn width="100%"  variant="text" :to="{name:'ostadino_policy'}" class="text-decoration-none p-2 text-black">قوانین و شرکت در مسابقه</v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </li>

        <li class="mr-1">
          <v-btn size="default" width="120px" class="text-decoration-none" style="letter-spacing: 0" :to="{ name: 'faq' }"
                 variant="text">
            سوالات متداول
          </v-btn>
        </li>

      </ul>
    </template>
    <div
      ref="dynamicRef"
      class="d-flex"
      :class="[!$vuetify.display.mdAndDown?'flex-row rounded-lg scroll-desktop' : 'without__scrollbar']"
    >
      <v-list
        v-model="list"
        id="menu"
        :max-height="!$vuetify.display.mdAndDown?'780px':''"
        :width="$vuetify.display.mdAndDown? mobileMenuWidth:'280'"
        class="first-step-menu border elevation-0 rounded-0 rounded-ts-lg"
        :class="[$vuetify.display.mdAndDown?'rounded-te-lg ':'rounded-bs-lg']"
      >
        <StepOne @openNextMenuLevel="openNextMenuLevel($event)" :items="menuItems"></StepOne>
      </v-list>
      <v-scroll-x-reverse-transition>
        <v-list
          v-model="list"
          v-if="secondLevelItems.length && menuStatus"
          :max-height="menuHeight"
          :min-height="menuHeight"
          :min-width="$vuetify.display.mdAndDown?'100%':'230'"
          :class="[
          $vuetify.display.mdAndDown?'border-t-sm':'',
          secondLevelItems.length && menuStatus && $vuetify.display.mdAndDown?'position-absolute rounded-t-lg':'align-items-center']"
          class="d-flex flex-column justify-content-start elevation-0 border-t-sm  border-b-sm  rounded-0 second-step-menu"
        >
          <StepTwo
            @openNextMenuLevel="openNextMenuLevel($event)"
            @backToPrevStep="backToPrevStep($event)"
            :items="secondLevelItems"
            :lastOptionSelected="latestStepsSelected"></StepTwo>
        </v-list>
      </v-scroll-x-reverse-transition>
      <v-scroll-x-reverse-transition>
        <v-list
          v-if="thirdLevelItems.length && menuStatus"
          :min-height="!$vuetify.display.mdAndDown?menuHeight:mobileMenuHeight"
          :max-height="menuHeight"
          :min-width="$vuetify.display.mdAndDown?'100%':'550'"
          :class="[thirdLevelItems.length && menuStatus && $vuetify.display.mdAndDown?'position-absolute rounded-t-lg':'']"
          class="third-step-menu py-0 elevation-0 border-sm rounded-0">
          <StepThree
            @backToPrevStep="backToPrevStep($event)"
            :items="thirdLevelItems"
            :lastOptionSelected="latestStepsSelected"></StepThree>
        </v-list>
      </v-scroll-x-reverse-transition>
      <v-scroll-x-reverse-transition>
        <v-list
          max-width="270"
          :min-height="menuHeight"
          :max-height="menuHeight"
          v-if="thirdLevelItems.length && menuStatus&& !$vuetify.display.mdAndDown"
          class="last-step-menu rounded-0 rounded-te-lg rounded-be-lg elevation-0 border-e-sm border-t-sm border-b-sm">
          <PromotionStep :items="promotionBanners"></PromotionStep>
        </v-list>
      </v-scroll-x-reverse-transition>
    </div>
  </v-menu>

</template>


<style lang="scss">
.last-step-menu {
  background: #F9FAFB !important;
}

.first-step-menu {
  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: column;

  }
}

.mega__menu__mobile {
  @include media-breakpoint-down(md){
    right: 0 !important;
  }
}

.menu-fixed-section {
  width: 100%;
  position: absolute;
  bottom: 0;
  backdrop-filter: blur(20px);

  button {
    letter-spacing: 0;
  }
}
.scroll-desktop{
  right:0!important;
  overflow-y: scroll!important;
}
</style>
